import { Input } from '@praxadon/ui';
import { Eye, EyeOff } from 'lucide-react';
import { type InputHTMLAttributes, useState } from 'react';

/** A password input with a show/hide toggle — typing a long passphrase blind is hard. */
export function PasswordInput(props: InputHTMLAttributes<HTMLInputElement>) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input {...props} type={visible ? 'text' : 'password'} className="pr-10" />
      <button
        type="button"
        onClick={() => {
          setVisible((v) => !v);
        }}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        className="absolute top-1/2 right-2 -translate-y-1/2 rounded p-1 text-fg-subtle hover:text-fg"
      >
        {visible ? <EyeOff size={16} aria-hidden /> : <Eye size={16} aria-hidden />}
      </button>
    </div>
  );
}

/** Live guidance under a new-password field. The server has the final word. */
export function passwordHint(password: string): string {
  const length = Array.from(password).length;
  if (length === 0)
    return 'At least 10 characters. A few random words make a strong, memorable password.';
  if (length < 10) return `${10 - length} more character${10 - length === 1 ? '' : 's'} to go.`;
  if (length < 16) return 'Good. Longer is even stronger.';
  return 'Strong password length.';
}
